interface RecaptchaService {
  evaluateBotScore: (
    action: string,
    token: string | undefined,
  ) => Promise<void | null>;
}

/* istanbul ignore next */
export const useRecaptchaService = (): RecaptchaService => {
  const evaluateBotScore = async (
    action: string,
    token: string | undefined,
  ): Promise<void | null> => {
    if (!token) return null;
    try {
      const botScoreResponse = await fetch(
        `/bot-score/bot-score-evaluations/v1/google-recaptcha-evaluations`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, action }),
        },
      );

      return await botScoreResponse.json();
    } catch {
      return null;
    }
  };
  return {
    evaluateBotScore,
  };
};
